import { render, staticRenderFns } from "./CardTarjaDancaHuck.vue?vue&type=template&id=5e7bc826&scoped=true"
import script from "./CardTarjaDancaHuck.vue?vue&type=script&lang=js"
export * from "./CardTarjaDancaHuck.vue?vue&type=script&lang=js"
import style0 from "./CardTarjaDancaHuck.vue?vue&type=style&index=0&id=5e7bc826&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e7bc826",
  null
  
)

export default component.exports